/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import './styles.sass';

const VirtualTourForm = (props) => {
  const { urls } = props;

  return (
    <div className="box-shadow" id="virtual-form">
      <div className="sidebar">
        <h3 className="sidebar-header arrowed arrowed--b colored--b">{I18n.t('virtual_office.form.legend')}</h3>
        <p>{I18n.t('virtual_office.form.main-text')}</p>

        <a target="_blank" rel="noopener noreferrer" href={urls.virtual}>
          {I18n.t('virtual_office.form.read_more_link')}
        </a>
      </div>
    </div>
  );
};

VirtualTourForm.propTypes = {
  urls: PropTypes.oneOfType([PropTypes.object]),
};

VirtualTourForm.defaultProps = {
  urls: {},
};

export default VirtualTourForm;
